export default function intialState() {
    return {
        user: false,
        organisations: {},
        organisationsById: [],
        activeOrganisationId: null
    }
}